import { render, staticRenderFns } from "./PointWithdrawComponent.vue?vue&type=template&id=e4292314&scoped=true&"
import script from "./PointWithdrawComponent.vue?vue&type=script&lang=js&"
export * from "./PointWithdrawComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4292314",
  null
  
)

export default component.exports